import { type FieldError, type Control, type FieldPath, type FieldValues, useController } from 'react-hook-form';
import Select, { type SelectProps } from '@repo/select';
import './ControlledSelect.css';

export interface ControlledSelectProps<TFieldValues extends FieldValues = FieldValues> extends Omit<SelectProps, 'error' | 'value' | 'onChange'> {
  name: FieldPath<TFieldValues>;
  control: Control<TFieldValues>;
  error?: FieldError;
  /** false — не показывать ошибку (для визарда до нажатия «Далее»/submit) */
  showError?: boolean;
}

export default function ControlledSelect<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  error: errorProp,
  showError = true,
  className = '',
  ...props
}: ControlledSelectProps<TFieldValues>) {
  // Используем useController для работы с формой
  const { field, fieldState } = useController({
    control,
    name,
  });

  const error = showError ? fieldState.error || errorProp : undefined;

  const handleChange = (selectedValue: string | number | null) => {
    field.onChange(selectedValue);
  };

  const handleBlur = () => {
    field.onBlur();
  };

  return (
    <div className="controlled-select-wrapper">
      <Select
        className={className}
        value={field.value}
        onChange={handleChange}
        onBlur={handleBlur}
        {...props}
        // error обязательно ПОСЛЕ props, иначе rest перезапишет
        error={error ? error.message : undefined}
      />
    </div>
  );
}

